import type { EventId, PlanEvent } from "../../../../shared/types";
import type { UpdateEventData } from "../../types/event-form-types";

interface EventItemFieldsProps {
  readonly event: PlanEvent;
  readonly editingField: string | null;
  readonly editValue: string;
  readonly onStartEdit?: (field: string, value: string) => void;
  readonly onSaveEdit?: () => void;
  readonly onEditValueChange?: (value: string) => void;
  readonly onUpdate?: (id: EventId, updates: UpdateEventData) => void;
}

export function EventItemFields({
  event,
  editingField,
  editValue,
  onStartEdit,
  onSaveEdit,
  onEditValueChange,
  onUpdate,
}: EventItemFieldsProps) {
  function handleRemoveTag(tag: string) {
    const newTags = event.tags.filter((t) => t !== tag);
    onUpdate?.(event.id, { tags: newTags });
  }

  return (
    <>
      {event.description && (
        <div>
          <div className="text-xs font-medium text-ink-muted mb-1">
            Description
          </div>
          {editingField === "description" ? (
            <textarea
              value={editValue}
              onChange={(e) => onEditValueChange?.(e.target.value)}
              onBlur={() => onSaveEdit?.()}
              rows={2}
              className="w-full px-2 py-1 text-sm bg-surface border border-accent focus:outline-none resize-none"
            />
          ) : (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onStartEdit?.("description", event.description);
              }}
              className="text-sm text-ink whitespace-pre-wrap break-words cursor-text hover:text-accent"
            >
              {event.description}
            </div>
          )}
        </div>
      )}

      {event.notes && (
        <div>
          <div className="text-xs font-medium text-ink-muted mb-1">Notes</div>
          {editingField === "notes" ? (
            <textarea
              value={editValue}
              onChange={(e) => onEditValueChange?.(e.target.value)}
              onBlur={() => onSaveEdit?.()}
              rows={2}
              className="w-full px-2 py-1 text-sm bg-surface border border-accent focus:outline-none resize-none"
            />
          ) : (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onStartEdit?.("notes", event.notes);
              }}
              className="text-sm text-ink-muted whitespace-pre-wrap break-words cursor-text hover:text-accent"
            >
              {event.notes}
            </div>
          )}
        </div>
      )}

      {event.tags.length > 0 && (
        <div>
          <div className="text-xs font-medium text-ink-muted mb-1">Tags</div>
          <div className="flex gap-1 flex-wrap">
            {event.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1 px-2 py-1 text-xs bg-accent text-white rounded-full"
              >
                {tag}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveTag(tag);
                  }}
                  className="hover:opacity-70"
                >
                  x
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
